module.exports = __webpack_public_path__ + "a3d131225a2e1f508cc816154f01eb74.jpg";